import type { AdminDashboardStatsResponse } from '@/js/account/entities/dashboard/model/types';
import { accountHttp } from '@/js/account/shared/api';

export async function accountAdminDashboardShow(): Promise<AdminDashboardStatsResponse> {
  const { data } = await accountHttp.get<AdminDashboardStatsResponse>('/dashboard');

  return data;
}
